import { Box } from '@mui/material';
import { OrganizationBillingComponent } from './_/OrganizationBilling/OrganizationBilling';

const makeStyles = () => ({
  pageContainer: {
    height: '100%',
  },
});

export function OrganizationBillingPage() {
  const sx = makeStyles();
  return (
    <Box sx={sx.pageContainer} display="flex" justifyContent="flex-start" alignItems="center" flexDirection="column" gap={2}>
      <OrganizationBillingComponent />
    </Box>
  );
}
